/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  close: {
    type: [String, Boolean, Function],
    "default": false
  },
  "default": {
    type: [String, Function]
  },
  icon: {
    type: Function
  },
  maxLine: {
    type: Number,
    "default": 0
  },
  message: {
    type: [String, Function]
  },
  operation: {
    type: Function
  },
  theme: {
    type: String,
    "default": "info",
    validator: function validator(val) {
      return ["success", "info", "warning", "error"].includes(val);
    }
  },
  title: {
    type: [String, Function]
  },
  onClose: Function,
  onClosed: Function
};

export { props as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/alert/props.js
// module id = null
// module chunks = 